import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { TranslateModule } from '@ngx-translate/core';

import { FileInputModule } from '@app/src/app/components/Input/FileInput';
import { FileInputUploadModule } from '@app/src/app/components/Input/FileInputUpload';
import { FileUploadModule } from '@app/src/app/components/Input/FileUpload';
import { MgTextareaModule } from '@app/src/app/components/Textarea';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgPasswordModule } from '@app/src/app/password';

import { FormModule } from '@shared/components/form';

@NgModule({
  exports: [
    // Minga dependencies
    MgFormFieldModule,
    FileInputModule,
    FileUploadModule,
    FileInputUploadModule,
    MgTextareaModule,
    MgPasswordModule,
    FormModule,

    // External dependencies
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    TranslateModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatRadioModule,
  ],
})
export class CommonFormModules {}
